import * as React from "react";
import { Component } from "react";
import { Button, FormGroup, Glyphicon, Table } from "react-bootstrap";
import CurrencyField from "src/components/common/CurrencyField";
import "src/css/components/projects/project/powerTable/guaranteedpowertable.css";
import { IBaseState } from "src/interfaces";
import { IGuaranteedPowerTableRow } from "src/pages/projects/project/powerTable/interfaces";
import { IGuaranteedPowerTableProps } from "./interfaces";

export default class GuaranteedPowerTable extends Component<
  IGuaranteedPowerTableProps,
  IBaseState
> {
  public constructor(props: IGuaranteedPowerTableProps) {
    super(props);
    this.state = {
      loading: true,
    };

    this.deleteRow = this.deleteRow.bind(this);
    this.handleProductionAnniversaryChanged = this.handleProductionAnniversaryChanged.bind(this);
    this.handleCumulativeEstimatedPowerChanged = this.handleCumulativeEstimatedPowerChanged.bind(
      this
    );
    this.handleCumulativeGuaranteedPowerChanged = this.handleCumulativeGuaranteedPowerChanged.bind(
      this
    );
    this.handleLeasePaymentChanged = this.handleLeasePaymentChanged.bind(this);
    this.handleBudgetPaymentChanged = this.handleBudgetPaymentChanged.bind(this);

    this.calculateAverageEstimatedPower = this.calculateAverageEstimatedPower.bind(this);
    this.calculateAverageGuaranteedPower = this.calculateAverageGuaranteedPower.bind(this);
  }

  public render() {
    return (
      <div className="container">
        <Table className="guaranteedPowerTable" striped={true} bordered={true}>
          <thead>
            <tr>
              <th className="report-header">Production Anniversary</th>
              <th className="report-header">Cumulative Estimated Power</th>
              <th className="report-header">Cumulative Guaranteed Power</th>
              <th className="report-header">Average Estimated Power</th>
              <th className="report-header">Average Guaranteed Power</th>
              <th className="report-header">Lease Payment</th>
              <th className="report-header">Budget Payment</th>
              <th className="report-header">
                <Button tabIndex={-1} bsSize="small" bsStyle="danger" disabled={true}>
                  <Glyphicon glyph="glyphicon glyphicon-remove" />
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {this.props.guaranteedPowerTable &&
              this.props.guaranteedPowerTable.map((row, index) => (
                <tr key={row.id}>
                  <td className="report-cell">
                    <FormGroup bsSize="small" controlId="productionAnniverary">
                      <CurrencyField
                        object={row}
                        small={true}
                        inputType="currency"
                        name="productionAnniversary"
                        label=""
                        value={row.productionAnniversary}
                        onChange={this.handleProductionAnniversaryChanged}
                        selectAllOnFocus={true}
                        allowEmpty={false}
                        disabled={false}
                        allowNegative={false}
                        precision={0}
                      />
                    </FormGroup>
                  </td>
                  <td className="report-cell">
                    <FormGroup bsSize="small" controlId="cumulativeEstimatedPower">
                      <CurrencyField
                        object={row}
                        small={true}
                        inputType="currency"
                        name="cumulativeEstimatedPower"
                        label=""
                        value={row.cumulativeEstimatedPower}
                        onChange={this.handleCumulativeEstimatedPowerChanged}
                        selectAllOnFocus={true}
                        allowEmpty={false}
                        disabled={false}
                        allowNegative={false}
                        precision={0}
                      />
                    </FormGroup>
                  </td>
                  <td className="report-cell">
                    <FormGroup bsSize="small" controlId="cumulativeGuaranteedPower">
                      <CurrencyField
                        object={row}
                        small={true}
                        inputType="currency"
                        name="cumulativeGuaranteedPower"
                        label=""
                        value={row.cumulativeGuaranteedPower}
                        onChange={this.handleCumulativeGuaranteedPowerChanged}
                        selectAllOnFocus={true}
                        allowEmpty={false}
                        disabled={false}
                        allowNegative={false}
                        precision={0}
                      />
                    </FormGroup>
                  </td>
                  <td className="report-cell">
                    <FormGroup bsSize="small" controlId="averageEstimatedPower">
                      <CurrencyField
                        object={row}
                        small={true}
                        inputType="currency"
                        name="averageEstimatedPower"
                        label=""
                        value={row.averageEstimatedPower}
                        onChange={undefined}
                        selectAllOnFocus={false}
                        disabled={true}
                        precision={0}
                        allowNegative={false}
                        allowEmpty={false}
                      />
                    </FormGroup>
                  </td>
                  <td className="report-cell">
                    <FormGroup bsSize="small" controlId="averageGuaranteedPower">
                      <CurrencyField
                        object={row}
                        small={true}
                        inputType="currency"
                        name="averageGuaranteedPower"
                        label=""
                        value={row.averageGuaranteedPower}
                        onChange={undefined}
                        selectAllOnFocus={false}
                        disabled={true}
                        precision={0}
                        allowNegative={false}
                        allowEmpty={false}
                      />
                    </FormGroup>
                  </td>
                  <td className="report-cell">
                    <FormGroup bsSize="small" controlId="leasePayment">
                      <CurrencyField
                        object={row}
                        small={true}
                        inputType="currency"
                        name="leasePayment"
                        label=""
                        value={row.leasePayment}
                        onChange={this.handleLeasePaymentChanged}
                        selectAllOnFocus={true}
                        disabled={false}
                        precision={2}
                        prefix={"$"}
                        allowNegative={true}
                        allowEmpty={false}
                      />
                    </FormGroup>
                  </td>
                  <td className="report-cell">
                    <FormGroup bsSize="small" controlId="budgetPayment">
                      <CurrencyField
                        object={row}
                        small={true}
                        inputType="currency"
                        name="budgetPayment"
                        label=""
                        value={row.budgetPayment}
                        onChange={this.handleBudgetPaymentChanged}
                        selectAllOnFocus={true}
                        disabled={false}
                        precision={2}
                        prefix={"$"}
                        allowNegative={true}
                        allowEmpty={false}
                      />
                    </FormGroup>
                  </td>
                  <td className="report-cell">
                    <Button
                      tabIndex={-1}
                      bsSize="small"
                      bsStyle="danger"
                      // tslint:disable-next-line:jsx-no-lambda
                      onClick={() => this.deleteRow(row)}
                    >
                      <Glyphicon glyph="glyphicon glyphicon-remove" />
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );
  }

  private deleteRow(row: IGuaranteedPowerTableRow) {
    this.props.deleteRow(row);
  }
  private handleProductionAnniversaryChanged(
    e: any,
    row: IGuaranteedPowerTableRow,
    floatValue: number
  ) {
    row.productionAnniversary = floatValue;
    row.averageEstimatedPower = this.calculateAverageEstimatedPower(
      row.productionAnniversary,
      row.cumulativeEstimatedPower
    );
    row.averageGuaranteedPower = this.calculateAverageGuaranteedPower(
      row.productionAnniversary,
      row.cumulativeGuaranteedPower
    );
    this.props.updateRow(row);
  }
  private handleCumulativeEstimatedPowerChanged(
    e: any,
    row: IGuaranteedPowerTableRow,
    floatValue: number
  ) {
    row.cumulativeEstimatedPower = floatValue;
    row.averageEstimatedPower = this.calculateAverageEstimatedPower(
      row.productionAnniversary,
      row.cumulativeEstimatedPower
    );
    row.averageGuaranteedPower = this.calculateAverageGuaranteedPower(
      row.productionAnniversary,
      row.cumulativeGuaranteedPower
    );
    this.props.updateRow(row);
  }
  private handleCumulativeGuaranteedPowerChanged(
    e: any,
    row: IGuaranteedPowerTableRow,
    floatValue: number
  ) {
    row.cumulativeGuaranteedPower = floatValue;
    row.averageGuaranteedPower = this.calculateAverageGuaranteedPower(
      row.productionAnniversary,
      row.cumulativeGuaranteedPower
    );
    this.props.updateRow(row);
  }
  private handleLeasePaymentChanged(e: any, row: IGuaranteedPowerTableRow, floatValue: number) {
    row.leasePayment = floatValue;
    this.props.updateRow(row);
  }
  private handleBudgetPaymentChanged(e: any, row: IGuaranteedPowerTableRow, floatValue: number) {
    row.budgetPayment = floatValue;
    this.props.updateRow(row);
  }
  private calculateAverageEstimatedPower(
    productionAnniveraary: number,
    cumulativeEstimatedPower: number
  ): number {
    if (productionAnniveraary <= 0) {
      return 0;
    }
    if (cumulativeEstimatedPower <= 0) {
      return 0;
    }
    const result = cumulativeEstimatedPower / (productionAnniveraary * 12);
    if (isNaN(result)) {
      return 0;
    }
    return result;
  }
  private calculateAverageGuaranteedPower(
    productionAnniversary: number,
    cumulativeGuaranteedPower: number
  ): number {
    if (productionAnniversary <= 0) {
      return 0;
    }
    if (cumulativeGuaranteedPower <= 0) {
      return 0;
    }
    const result = cumulativeGuaranteedPower / (productionAnniversary * 12);
    if (isNaN(result)) {
      return 0;
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/powerTable/GuaranteedPowerTable.tsx